import React from "react";

function Error() {
  return <div className="Error">An error has occurred.</div>;
}

export default Error;
